import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { whatToDoChapter } from '@/learning-paths/incode/what-to-do/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/what-to-do')({
  component: WhatToDoRoute,
})

function WhatToDoRoute() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={whatToDoChapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
